import React from 'react';
import { useForm } from './useForm';
export function withForm(Target) {
  var Wrapped = function Wrapped(props) {
    var form = useForm({
      model: {}
    });
    return React.createElement(Target, Object.assign({}, props, {
      form: form
    }));
  };

  return Object.assign(Wrapped, Target);
}